
$('.agregar .descuento').fadeOut(1)
$(document).ready(function() {
  var total = 0;
  var compare = 0;
  // da formato al precio
  const formatterPeso = new Intl.NumberFormat('es-CL', {
    minimumFractionDigits: 0
  });

  $('body').on('click', '.product .build-pack__var .add', function() {
    var val           = parseInt($(this).parent().attr('item-value'));
    var proimg        = $(this).parent().attr('item-image');
    var stock         = $(this).parent().attr('item-stock'); 
    // var precio  = parseInt($(this).parent().attr('item-price__secondary'));
    var precio        = $(this).parent().attr('item-price__secondary');

    var p_product     = precio.substring(0,precio.length-2);
    var precio2       = $(this).parent().attr('item-price__compare2');
    var p_product2    = precio2.substring(0,precio2.length-2);
    var package       = $(this).parent().parent().parent().parent().find('li.empty').first(),
        class_clicked = '.' + ($(this).parent().parent().parent().parent().attr('class')).replace(/\s/g, '.');
    if ($('.pack-block.packtive').find("input[value='" + val + "']").length < stock) {
      $(package).removeClass('empty').addClass('full').find('.proimg').attr('src', proimg);
      $(package).attr('item-price', precio);
      $(package).attr('item-price__compare', precio2);
      $(package).children('input').val(val);
      total = total + parseInt(p_product);
      compare = compare + parseInt(p_product2)
      var emptySize = $(class_clicked + ' .slots ul li.empty').length;
      if (emptySize == 0 ) { 
        $(class_clicked + ' .agregar .disable').fadeOut(1);
        $(class_clicked).addClass('notempty');
        $(class_clicked).removeClass('empty');
      } else {
        $(class_clicked + ' .agregar .disable').fadeIn(1);
        $(class_clicked).removeClass('notempty');
        $(class_clicked).addClass('empty');
      }
    } else {
      alert("Solo quedan " + stock + " en stock");
    }  
    // muestra el descuento
    $('.agregar .descuento').fadeIn(1)

    // agrega el precio a precio total y referencial
    $('.precio-pack span').text(formatterPeso.format(total))
    $('.precio-referencial span').text(formatterPeso.format(compare))

    $('.agregar .descuento').text((((total / compare) * 100) - 100).toFixed().replace('-', '') + '%' + ' ' + 'OFF')
  });

  $('.pack-cart .quitar').click(function() {
    var precio        = $(this).parent().attr('item-price');
    var p_product     = precio.substring(0,precio.length-2);
    var precio2       = $(this).parent().attr('item-price__compare');
    var p_product2    = precio2.substring(0,precio2.length-2);
    var package       = $(this).parent().parent().parent().parent().find('li.full').last()
    $(this).parent('li').addClass('empty').removeClass('full');
    $(this).siblings('input').val('');
    var parIndex      = $(this).parent('li').index() + 1,
    class_clicked = '.' + ($(this).parent().parent().parent().parent().attr('class')).replace(/\s/g, '.');
    $(package).removeAttr('item-price', precio);
    $(package).removeAttr('item-price__compare', precio2);
    $(class_clicked).parent().removeClass('notempty');
    $(class_clicked).parent().addClass('empty');
    var emptySize = $(class_clicked + ' .slots ul li.empty').length;
    if (emptySize < 12 ) {
      $(class_clicked + ' .agregar .disable').fadeIn(1);
    } else {
      $(class_clicked + ' .agregar .disable').fadeOut(1);
    }

    total = total - parseInt(p_product);
    compare = compare - parseInt(p_product2);
    if(total == 0 ) {
      $('.agregar .descuento').fadeOut(1)
    } else {
      $('.agregar .descuento').fadeIn(1)
    }

    $('.precio-pack span').text(formatterPeso.format(total));
    $('.precio-referencial span').text(formatterPeso.format(compare));

    $('.agregar .descuento').text((((total / compare) * 100) - 100).toFixed().replace('-', '') + '%' + ' ' + 'OFF')

  });

  $('body').on("click", ".pack-cart .agregar .tocart", function() {
    var pack_type = $(this).attr('data-pack-type'),
        iden      = Math.floor((Math.random() * 10000000000000000000) + 1), jqxhr, $array_items = [],
        cantidad  = $(this).data('cantidad'),
        first_array = {},
        _this       = this;
    $(this).addClass('clicked').removeClass('tocart');;

    $('.' + pack_type + ' .pack-cart .slots ul li input').each(function(index){
      var inputVal = $(this).val();
      if (first_array[inputVal] === undefined) {
        first_array[inputVal] = 1;
      } else {
        first_array[inputVal] += 1;
      }
    });

    $.each(first_array, function (i, data) {
      $array_items.push({
        quantity: data,
        id: i,
        properties: {
          'Producto': 'Crea tu Pack ' + cantidad,
          'Iden': 'pack' + iden
        }
      });
    });

    console.log('Array', $array_items);
    console.log('items', items);

    jqxhr = jQuery.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: { items: $array_items },
      success: function(data) {
      },
      error: function(data) {
        if (data.status == 422) {
          //$('.alertas').text(proName + ' no tiene stock disponible');
        }
      },
      async: true
    });

    jqxhr.always(function() {
      $(_this).text('Pack agregado > Ir a pagar ');
      $(_this).attr("href", "/cart");
      /*setTimeout(function() {
        
        location.reload();
      }, 2000);*/
      
      $('.' + pack_type + ' .pack-cart .agregar .otra').addClass('show');
      /*$(_this).text('Ir a pagar ›');
      
      update_mini_cart(false, true);
      $(_this).removeClass("clicked").attr("href", "/cart");*/
    });
  });

   // Carrito
   $('.carrito tbody tr[data-id="pack"]').each(function(){
    var proiden = $(this).data('packid');
  });

  var $tr   = $('.carrito tbody tr[data-id="pack"]'),
      items = {};

  $tr.each(function() {
    items[$(this).data('packid')] = '';
  });

  for (item in items) {
    $tr.filter('[data-packid='+ item +']').first().append( "<td class='quitar quitar" + item + "' data-quitar='" + item + "'><span><i>+</i></span></p>");
    $tr.filter('[data-packid='+ item +']').last().addClass('ultimo');
  }

  $('.carrito tbody tr[data-id="pack"] td.quitar').on('click', function(){
    var toRemove   = $(this).data('quitar');
    var qty        = 0;
    var data       = { updates: {} };
    var itemsArray = $('.carrito tbody tr[data-packid="' + toRemove + '"]').map(function(i,v){
      return $(v).data('item');
    }).get();
    for (i = 0; i < itemsArray.length; i++) {
      data.updates[itemsArray[i]] = qty;
    }
    jQuery.post('/cart/update.js',
      data
    ).always(function() {
      location.reload();
    });
  });
});